import React from "react";

export type CtaImageProps = {
  url: string;
  altText: string;
};

export const CtaImage: React.FC<CtaImageProps> = ({
  url,
  altText,
}: CtaImageProps) => {
  return (
    <div className="full-width-cta__image">
      <img src={url} alt={altText} />
    </div>
  );
};
